import classNames from 'classnames'
import React, { ReactElement } from 'react'
import { Button } from '@conekta/frontino-ui/Button'
import { getButtonProps } from 'components/FileUploader/helper'
import { IRightSideButton } from 'components/FileUploader/interface'
import { useTranslation } from 'react-i18next'
import '../RightSide.scss'

const T_ROOT = 'fileUploader'

const RightSideButton = ({
  defaultFileName,
  defaultFileURL,
  disabled,
  isFailUpload,
  isFileAccepted,
  isFileRejected,
  loading,
  noDrag,
  onClick,
  onClickDelete
}: IRightSideButton): ReactElement => {
  const { t } = useTranslation()
  const showDragText = !noDrag && !disabled && !isFileRejected && !isFileAccepted
  const hasDefaultFile = Boolean(defaultFileURL) && Boolean(defaultFileName)

  const buttonClasses: string = classNames('file-area__button', {
    'file-area__button--disabled': disabled && !hasDefaultFile,
    'file-area__button--selected': isFileAccepted,
    'file-area__button--showed': hasDefaultFile
  })

  const dragText = t(`${T_ROOT}.dragText`)

  const { handleClick, label } = getButtonProps({
    defaultFileURL: defaultFileURL ?? '',
    disabled,
    hasDefaultFile,
    isFailUpload,
    isFileAccepted,
    isFileRejected,
    onClick,
    onClickDelete,
    t
  })

  return (
    <>
      {showDragText && <p className='file-area__drag-text'>{dragText}</p>}
      <Button
        className={buttonClasses}
        type='button'
        variant='secondary'
        disabled={(disabled && !hasDefaultFile) || loading}
        loading={loading}
        onClick={handleClick}
      >
        {label}
      </Button>
    </>
  )
}

export default RightSideButton
